import {UserFormValuesExtractor} from './userFormValuesExtractor';
import {initActivityForm} from './activity';
import CookiesJS from 'cookies-js';
import {submitHandler} from '../submit-handler';
import {startBuildAfterSave} from './rebuildProgramms';
import { initGoalBalance } from './goalBalance';

export function initPersonal($, apiClient) {
    const form = document.querySelector('form.personal-form:not(.client-form)');
    if (!form) return;
    const goalBalance = initGoalBalance(form);
    initActivityForm();
    const valuesExtractor = new UserFormValuesExtractor();
    // Кнопка живёт в нижней панели, а она лежит рядом с формой,
    // а не внутри неё. Селектор с `form.personal-form` внутри ничего
    // не находил, обработчик не вешался, и нажатие молча ничего
    // не делало (разбор 12.10).
    submitHandler('.action__personal', async function () {
        const user = valuesExtractor.extractUserParams();
        // Эксперт настраивает и свою программу: дефицит полем, белок
        // и жиры ползунками. У клиента этих контролов на странице нет,
        // и тогда ничего не отправляется (доступ по роли, 26.10).
        const modifier = $('#calorieModifier').val();
        if (modifier !== undefined && String(modifier).trim() !== '') {
            user.statsOverrides = { calorieModifier: parseFloat(modifier) / 100 };
        }
        const balance = document.querySelector('.macro-balance');
        if (balance && typeof balance.getBalanceOverrides === 'function') {
            const overrides = balance.getBalanceOverrides();
            if (Object.keys(overrides).length) {
                user.statsOverrides = Object.assign({}, user.statsOverrides, overrides);
            }
        }
        const goalChanged = goalBalance.prepare(user);
        await apiClient.updateUser(user, CookiesJS.get('auth_token'));
        // Сохранение в режиме автогенерации запускает сборку.
        try {
            await startBuildAfterSave(apiClient);
        } finally {
            if (goalChanged) window.location.reload();
        }
    });
}
